import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import FirebaseService from '../service/FirebaseService';

import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from 'react-image-gallery';

import { Helmet } from "react-helmet";
import base from '../rebase';

var _ = require('lodash');
var ReactGA = require('react-ga');

class MyImageSliderComponent extends React.Component {

    handleImageLoad(event) {
        // console.log('Image loaded ', event.target)
    }

    render() {
        var images = [];
        if (_.size(this.props.images) > 0) {
            this.props.images.map((image) => images.push({ 
                original: image.url,
                thumbnail: image.thumbnailUrl 
            }))
        } else {
            return <img className="img-fluid" src="../img/icons/no-image-available.png" />
        }

        return (
            <ImageGallery
                items={images}
                slideInterval={2000}
                onImageLoad={this.handleImageLoad}
                lazyLoad={true}
                showPlayButton={false}
                defaultImage="../img/transparent.png" />
        )

    }

}

class AttachmentDetails extends React.Component {
    render() {
        var name = this.props.id.split('_')

        if (_.size(name) > 1) {
            name = name[1];
        }

        return (
            <p><Link className="card-text" to={"../attachment/" + this.props.id} target="blank" > {name}</Link ></p>
        )
    }
}

class ImageDetails extends React.Component {
    render() {
        var img = this.props.id;
        // var name = this.props.id.split('_')

        // if (_.size(name) > 1) {
        //     name = name[1];
        // }

        return (
            <a href="#" data-img-zoom={"../img/products/" + img}>
                <img src={"../img/products/" + img} className="lazyOwl img-fluid" width="150" />
            </a>
        )
    }
}

class ImageThumbDetails extends React.Component {
    render() {
        var img = this.props.id;

        return (
            <a className="owl-thumb">
                <img className="img-fluid" src={"../img/products/" + img} />
            </a>
        )
    }
}





export default class ProductDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            product: '',
            imagesToShow: [],
            notFound: false,
            loading: true

        }

        var res = this.props.match.params.productId.split('--')
        var code = _.last(res);

        var productsArrayFromDb = FirebaseService.findProductFromDatabase(code, productCallback => {

            if (productCallback != undefined && productCallback != null && _.size(productCallback) > 0) {

                var product = productCallback[Object.keys(productCallback)[0]];
                var imagesToShow = [];
                if (_.size(product.images) > 0) {
    
                    //get single image details from DB, then add it to a local state which stores all images
                    _.map(product.images , img=> FirebaseService.findProductImageFromDatabase(img, imageCallBack => {
                        if (imageCallBack != undefined && imageCallBack != null && _.size(imageCallBack) > 0){
                            this.setState({
                                imagesToShow: this.state.imagesToShow.concat(_.toArray(imageCallBack))
                            });
                        }
                    }));        
                } else { //old way of displaying images that is done after old site data migration
                    if (_.size(product.image) > 0) {
                        imagesToShow.push({ id: product.image });
                    }
                }

                //TODO: Brand needs chinese translation
                //replace language
                if(this.props.language == "chi") {
                    product.displayName = product.name_chi;
                } else {
                    product.displayName = product.name;
                }

                //then find the brand
                base.fetch('brands', {
                    context: this,
                    asArray: false
                }).then(data => {
                    if(this.props.language == "chi") {
                        product.brandDisplayName = data[product.brand_id].name;                    
                    } else {
                        product.brandDisplayName = data[product.brand_id].name;                    
                    }
                    
                    this.setState({
                        product: product,
                        notFound: false,
                        loading: false
                    });
                }).catch(error => {
                    product.brandData = "";

                    this.setState({
                        product: product,
                        notFound: false,
                        loading: false
                    });
                })

            } else {
                this.setState({
                    notFound: true,
                    loading: false
                })

                ReactGA.exception({
                    description: 'Cannnot load product: ' + code + " full url:" + window.location.pathname,
                    fatal: true
                });
            }
        });

        this.findProductImageByid = this.findProductImageByid.bind(this);
    }


    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0)
        }
    }

    findProductImageByid(id){
        //image doesnt work becase it is not in the promise return from db script. Need to set state in the db script callback
        var image = FirebaseService.findProductImageFromDatabase(id);
        // console.log("findProductImageByid : ");
        // console.log(image);
        return image;
    }

    render() {
        const containerStyle = {
            // margin: "0 auto",
            // padding: "20px"
            // width: "80 %",
            // color: "#333",
            // background: "#419be0"
        }

        window.scrollTo(0, 0);
        var productCardArea = '';
        var currentProductDetails = this.props.match.params.productId;

        if (_.size(currentProductDetails) > 0) {
            //show current product details
            productCardArea = (<div>{this.props.getTranslatedText("ShowingProducts")} {currentProductDetails}</div>)
        }

        const brStyle = {
            minHeight: '800px',
            padding: '400 0 500 0'
        };
        // this.state.displayedProducts.map(product => <ProductCard key={product.code} products={product} />);

        var attachmentArea = ''
        if (_.size(this.state.product.attachment) > 0) {
            attachmentArea = this.state.product.attachment.map(attach => <AttachmentDetails id={attach.id} key={attach.id} />);
        };

        var imageArea = ''
        if (_.size(this.state.product.image) > 0) {
            imageArea = <ImageDetails id={this.state.product.image} />;
            // imageArea = this.state.product.image.map(img => <ImageDetails id={img} />);
        };

        var imageThumbArea = ''
        if (_.size(this.state.product.image) > 0) {
            imageThumbArea = <ImageThumbDetails id={this.state.product.image} />;
            // imageArea = this.state.product.image.map(img => <ImageDetails id={img} />);
        };

        var relatedArea = ''
        if (_.size(this.state.product.related) > 0) {
            var relatedArea = ''
            var related2 = this.state.product.related.split(",");
            relatedArea = related2.map(re => <div key={re}><p className="card-text">{re}</p></div>
                // FirebaseService.findProductFromDatabase(re, productCallback => {
                //     console.log("productCallback : ", productCallback)
                //     var product = productCallback[Object.keys(productCallback)[0]];
                //     var productDetailsLink = "/product/" + product.name.split(' ').join('-') + "--" + product.code.split(' ').join('-');
                // return <Link to={productDetailsLink}></Link>
                // })
            );
        }

    

        return (//
            <div>
                {this.state.loading &&
                    <div style={brStyle} className="container my-4">
                        <Helmet>
                            <title>{'Preseli Engineering Supplies: Loading...'}</title>
                        </Helmet>
                        <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i><span className=""> {this.props.getTranslatedText("Loading")}</span>
                    </div>
                }
                {this.state.notFound &&
                    <div style={brStyle} className="container my-4">
                        <Helmet>
                            <title>{'Preseli Engineering Supplies'}</title>
                        </Helmet>

                        <Link to={'/products'} className=""><i className="fa fa-chevron-left"></i> {this.props.getTranslatedText("Back")}</Link>
                        <h4 className="my-4">{this.props.getTranslatedText("InvalidLink")}</h4>
                    </div>
                }
                {!this.state.notFound &&

                    <div style={brStyle} className={"container " + (this.state.notFound ? "hidden" : "")} >
                        <Helmet>
                            <title>{'Preseli Engineering Supplies: ' + this.state.product.displayName + ' - ' + this.state.product.brand}</title>
                            <meta name="description" content={'View ' + this.state.product.name + ' by ' + this.state.product.brand + '. '+ this.state.product.feature} />
                            <meta name="keyword" content={this.state.product.brandDisplayName + ' ' + this.state.product.name + ' Engineer Supplies'}/>
                        </Helmet>

                        <Row>
                            <Link to={'/products'} className="my-4"><i className="fa fa-chevron-left"></i> {this.props.getTranslatedText("Back")}</Link>
                        </Row>
                        <hr></hr>
                        <div id="content" className="pt-3 pt-lg-6 pb-lg-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <div className="slider-wrapper" style={containerStyle}>
                                            <MyImageSliderComponent images={this.state.imagesToShow} />
                                        </div>
                                        {/*<!-- Shop product carousel Uses Owl Carousel plugin All options here are customisable from the data-owl-carousel-settings="{OBJECT}" item via data- attributes: http://www.owlgraphic.com/owlcarousel/#customizing ie. data-settings="{"items": "4", "lazyLoad":"true", "navigation":"true"}" -->*/}
                                        {/* <div className="product-gallery pos-relative"> */}

                                        {/*<div className="owl-carousel owl-nav-over" id="product-gallery" data-toggle="owl-carousel" data-owl-carousel-settings='{"responsive":{"0":{"items":1,"nav":true, "dots":false}}}'>
                                        {imageArea}*/}
                                        {/*<a href="#" data-img-zoom="assets/img/shop/shoes-2.jpg">
                                            <img src="assets/img/shop/shoes-2.jpg" alt="Shoes image" className="lazyOwl img-fluid" width="200" />
                                        </a>
                                        <a href="#" data-img-zoom="assets/img/shop/mens-sports-2.jpg">
                                            <img src="assets/img/shop/mens-sports-2.jpg" alt="Nike Training Top image" className="lazyOwl img-fluid" width="200" />
                                        </a>
                                        <a href="#" data-img-zoom="assets/img/shop/promo-kids.jpg">
                                            <img src="assets/img/shop/promo-kids.jpg" alt="Kids Wolly Jumper image" className="lazyOwl img-fluid" width="200" />
                                        </a>
                                        <a href="#" data-img-zoom="assets/img/shop/promo-kids-hoodies.jpg">
                                            <img src="assets/img/shop/promo-kids-hoodies.jpg" alt="Kids Hoodies image" className="lazyOwl img-fluid" width="200" />
                                        </a>
                                        <a href="#" data-img-zoom="assets/img/shop/mens-sports.jpg">
                                            <img src="assets/img/shop/mens-sports.jpg" alt="Nike Training Top image" className="lazyOwl img-fluid" width="200" />
                                        </a>
                                        <a href="#" data-img-zoom="assets/img/shop/promo-mens-2.jpg">
                                            <img src="assets/img/shop/promo-mens-2.jpg" alt="Leather Jacket image" className="lazyOwl img-fluid" width="200" />
                                        </a>*/}
                                        {/*</div>*/}

                                        {/* <div className="owl-thumbs" data-toggle="owl-carousel" data-owl-carousel-thumbs="#product-gallery" data-owl-carousel-settings='{"nav":false, "dots":false, "margin":5}'> */}
                                        {/* {imageThumbArea} */}
                                        {/*<a className="owl-thumb">
                                            <img className="img-fluid" src="assets/img/shop/shoes-2.jpg" alt="Card image cap" />
                                        </a>
                                        <a className="owl-thumb">
                                            <img className="img-fluid" src="assets/img/shop/mens-sports-2.jpg" alt="Card image cap" />
                                        </a>
                                        <a className="owl-thumb">
                                            <img className="img-fluid" src="assets/img/shop/promo-kids.jpg" alt="Card image cap" />
                                        </a>
                                        <a className="owl-thumb">
                                            <img className="img-fluid" src="assets/img/shop/promo-kids-hoodies.jpg" alt="Card image cap" />
                                        </a>
                                        <a className="owl-thumb">
                                            <img className="img-fluid" src="assets/img/shop/mens-sports.jpg" alt="Card image cap" />
                                        </a>
                                        <a className="owl-thumb">
                                            <img className="img-fluid" src="assets/img/shop/promo-mens-2.jpg" alt="Card image cap" />
                                        </a>*/}
                                        {/* </div> */}
                                        {/* </div> */}
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="card product-card mb-4">
                                            <div className="card-block p-4 pos-relative">
                                                <p className="text-muted text-uppercase text-xs mb-0"><span className="text-primary">{this.state.product.brandDisplayName}</span> / {this.state.product.code}</p>
                                                <h2 className="card-title mb-2">{this.state.product.displayName}</h2>

                                                {_.size(this.state.product.feature) > 0 &&
                                                    <div>
                                                        <hr className="my-3" />
                                                        <p className="text-muted text-sm">{this.state.product.feature}</p>
                                                    </div>
                                                }

                                                {/*<hr className="my-3 mb-5" />*/}
                                                {/*<a href="shop-cart.htm" className="btn btn-primary"><i className="fa fa-cart-plus mr-2"></i> Add to Cart</a>*/}
                                                {/*<a href="#" className="btn btn-link btn-sm"><i className="fa fa-heart"></i> Add to Wishlist</a>*/}
                                                {/*<p className="text-muted text-xs d-inline hidden-md-down">12769 in stock</p>*/}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        {/*<!-- Product tabs, @see: elements-navs-tabbable.htm -->*/}
                                        <div className="card mt-5 border-top-0">
                                            <div className="card-header bg-white pt-0 px-0">
                                                <ul className="nav nav-tabs nav-justified card-header-tabs flex-column flex-md-row">
                                                    <li className="nav-item"> <a className="nav-link active py-md-4 text-uppercase font-weight-bold" href="#product-description" data-toggle="tab">{this.props.getTranslatedText("Details")}</a> </li>
                                                    <li className="nav-item"> <a className="nav-link py-md-4 text-uppercase font-weight-bold" href="#product-attachment" data-toggle="tab">{this.props.getTranslatedText("Attachment")}</a> </li>
                                                    <li className="nav-item"> <a className="nav-link py-md-4 text-uppercase font-weight-bold" href="#related-product" data-toggle="tab">{this.props.getTranslatedText("RelatedProducts")}</a> </li>

                                                </ul>
                                            </div>
                                            <div className="card-block p-4">
                                                <div className="tab-content">
                                                    {/*<!-- Tab 1: Description tab content -->*/}
                                                    <div className="tab-pane active show" id="product-description">
                                                        <h4 className="card-title">{this.props.getTranslatedText("ProductDescription")}</h4>
                                                        <p className="card-text">{this.state.product.feature}</p>
                                                        {/*<p className="card-text">Iriure plaga praesent typicus ut. Euismod exputo rusticus singularis ut venio vereor ymo. Ad dolus gemino in magna qui. Camur distineo hendrerit jumentum laoreet obruo pagus vicis.</p>*/}
                                                        {/*<p className="card-text">Haero velit zelus. Causa erat illum. Abico dolore iustum nunc nutus sed validus. Ad et gemino jus nulla occuro patria quia vero zelus.</p>*/}
                                                        {/*<p className="card-text">Abluo aliquip augue dolor laoreet pagus probo proprius veniam volutpat. Acsi appellatio cogo iriure jumentum magna occuro scisco uxor vicis.</p>*/}
                                                    </div>

                                                    <div className="tab-pane" id="product-attachment">
                                                        <h4 className="card-title">{this.props.getTranslatedText("Attachment")}</h4>

                                                        {attachmentArea}
                                                        {/*<p className="card-text">Iriure plaga praesent typicus ut. Euismod exputo rusticus singularis ut venio vereor ymo. Ad dolus gemino in magna qui. Camur distineo hendrerit jumentum laoreet obruo pagus vicis.</p>*/}
                                                        {/*<p className="card-text">Haero velit zelus. Causa erat illum. Abico dolore iustum nunc nutus sed validus. Ad et gemino jus nulla occuro patria quia vero zelus.</p>*/}
                                                        {/*<p className="card-text">Abluo aliquip augue dolor laoreet pagus probo proprius veniam volutpat. Acsi appellatio cogo iriure jumentum magna occuro scisco uxor vicis.</p>*/}
                                                    </div>
                                                    <div className="tab-pane" id="related-product">
                                                        <h4 className="card-title">{this.props.getTranslatedText("RelatedProducts")}</h4>
                                                        {relatedArea}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*<!-- /container -->*/}
                            <hr className="mt-6 mb-0" />
                            <div className="">
                                {/*<!-- Related Products -->*/}
                                {/*<div className="container py-4">
                            <hr className="hr-lg mt-0 mb-3 w-10 mx-auto hr-primary" />
                            <h2 className="text-center text-uppercase font-weight-bold my-0">Related Products</h2>
                            <hr className="mb-3 w-50 mx-auto" />
                            <div className="mt-4 owl-nav-over owl-nav-over-lg" data-toggle="owl-carousel" data-owl-carousel-settings='{"responsive":{"0":{"items":1}, "600":{"items":2}, "980":{"items":4}}, "margin":10, "nav":true, "dots":false}'>
                            
                                <div className="card product-card overlay-hover">
                                    
                                    <div className="overlay-hover-content overlay-op-7 product-card-hover-tools">
                                        <h4 className="text-white">New Balance</h4>
                                        <a href="shop-cart.htm" className="btn btn-primary text-uppercase font-weight-bold mb-2"><i className="fa fa-cart-plus mr-2"></i> Add to Cart</a>
                                    </div>
                                    
                                    <div className="pos-relative">
                                        <img className="card-img-top img-fluid" src="assets/img/shop/shoes-2.jpg" alt="Card image cap" />
                                        <span className="badge badge-primary product-price-badge pos-absolute pos-t pos-l mt-2 ml-2">
                                            <del className="op-5">$24.99</del>/ $19.99</span>
                                    </div>
                                </div>
                                
                                <div className="card product-card overlay-hover">
                                    
                                    <div className="overlay-hover-content overlay-op-7 product-card-hover-tools">
                                        <h4 className="text-white">Nike Training Top</h4>
                                        <a href="shop-cart.htm" className="btn btn-primary text-uppercase font-weight-bold mb-3"><i className="fa fa-cart-plus mr-2"></i> Add to Cart</a>
                                    </div>
                                    
                                    <div className="pos-relative">
                                        <img className="card-img-top img-fluid" src="assets/img/shop/mens-sports-2.jpg" alt="Card image cap" />
                                        <span className="badge badge-primary product-price-badge pos-absolute pos-t pos-l mt-2 ml-2">$39.99</span>
                                    </div>
                                </div>
                                
                                <div className="card product-card overlay-hover">
                                    <div className="overlay-hover-content overlay-op-7 product-card-hover-tools">
                                        <h4 className="text-white">Kids Wollys</h4>
                                        <a href="shop-cart.htm" className="btn btn-primary text-uppercase font-weight-bold mb-3"><i className="fa fa-cart-plus mr-2"></i> Add to Cart</a>
                                    </div>
                                    <div className="pos-relative">
                                        <img className="card-img-top img-fluid" src="assets/img/shop/promo-kids.jpg" alt="Card image cap" />
                                        <span className="badge badge-primary product-price-badge pos-absolute pos-t pos-l mt-2 ml-2">$9.99</span>
                                    </div>
                                </div>
                                <div className="card product-card overlay-hover">
                                    <div className="overlay-hover-content overlay-op-7 product-card-hover-tools">
                                        <h4 className="text-white">Kids Hoodies</h4>
                                        <a href="shop-cart.htm" className="btn btn-primary text-uppercase font-weight-bold mb-3"><i className="fa fa-cart-plus mr-2"></i> Add to Cart</a>
                                    </div>
                                    <div className="card-ribbon card-ribbon-top card-ribbon-right bg-primary text-white">Eco Friendly</div>
                                    <div className="pos-relative">
                                        <img className="card-img-top img-fluid" src="assets/img/shop/promo-kids-hoodies.jpg" alt="Card image cap" />
                                        <span className="badge badge-primary product-price-badge pos-absolute pos-t pos-l mt-2 ml-2">$29.99</span>
                                    </div>
                                </div>
                                <div className="card product-card overlay-hover">
                                    <div className="overlay-hover-content overlay-op-7 product-card-hover-tools">
                                        <h4 className="text-white">Shirts</h4>
                                        <a href="shop-cart.htm" className="btn btn-primary text-uppercase font-weight-bold mb-3"><i className="fa fa-cart-plus mr-2"></i> Add to Cart</a>
                                    </div>
                                    <div className="pos-relative">
                                        <img className="card-img-top img-fluid" src="assets/img/shop/promo-mens.jpg" alt="Card image cap" />
                                        <span className="badge badge-primary product-price-badge pos-absolute pos-t pos-l mt-2 ml-2">$69.99</span>
                                    </div>
                                </div>
                                <div className="card product-card overlay-hover">
                                    <div className="overlay-hover-content overlay-op-7 product-card-hover-tools">
                                        <h4 className="text-white">Jacket</h4>
                                        <a href="shop-cart.htm" className="btn btn-primary text-uppercase font-weight-bold mb-3"><i className="fa fa-cart-plus mr-2"></i> Add to Cart</a>
                                    </div>
                                    <div className="pos-relative">
                                        <img className="card-img-top img-fluid" src="assets/img/shop/promo-mens-2.jpg" alt="Card image cap" />
                                        <span className="badge badge-primary product-price-badge pos-absolute pos-t pos-l mt-2 ml-2">$199.99</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                            </div>
                        </div>
                    </div >
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/ProductDetails.js